<template>

<!--  <div>-->
    <v-app-bar
        app
        fixed
        flat
        dark

        color="#111877">


      <v-btn
          icon
          @click.stop="setDrawer(!drawer)"
          >

        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
      <div class="mx-1"/>
      <v-btn
        icon
        @click="$router.push('/home')">
      <v-icon >
        mdi-home
      </v-icon>


    </v-btn>
      <v-spacer/>
      <v-toolbar-title> مجتمع 8 تا 8</v-toolbar-title>

      <v-spacer></v-spacer>
      <v-btn
          v-if="can('userRequestReport') || can('unitEditReport') "
          class="ml-3"
          min-width="0"
          text
          to="/request"
      >
        <v-badge
            color="red"
        >
          <template v-slot:badge>
            <span   v-if="can('userRequestReport')&& !can('unitEditReport')" >{{countRequestUser}}</span>
            <span   v-if="!can('userRequestReport') && can('unitEditReport') " >{{countEditUnit}}</span>
            <span   v-if="can('userRequestReport') && can('unitEditReport') " >{{countRequestUser+countEditUnit}}</span>
          </template>

          <v-icon >fas fa-file-alt</v-icon>
        </v-badge>
      </v-btn>


      <v-menu
          bottom
          class="ml-3"
          left
          offset-y
          origin="top right"
          transition="scale-transition"
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
              class="ml-3"
              min-width="0"
              text
              v-bind="attrs"
              v-on="on"
              to="/message"
              v-if="can('messageList') "
          >
            <v-badge
                color="red"
            >
              <template v-slot:badge>
                <span>{{size}}</span>
              </template>

              <v-icon >fas fa-envelope</v-icon>
            </v-badge>
          </v-btn>
        </template>


      </v-menu>

      <see-msg :model="msg"  :showMsg.sync="showIs"/>


      <v-btn icon @click="logout=true">
        <v-icon>mdi-exit-to-app</v-icon>
        <logout  :logout.sync="logout"/>
      </v-btn>

    </v-app-bar>



</template>

<script>
import SeeMsg from '../../views/define/message/SeeMsg'
import Logout from '../../views/define/profile/Logout'
import {mapState, mapMutations} from 'vuex'
import Message_se from "../../views/define/message/Message_se";
import Request_se from "@/views/define/requestUser/Request_se"
export default {
  name: "NavBar",
  components:{
    SeeMsg,
    Logout
  },
  computed: {
    ...mapState(['drawer', 'mini']),
  },
data(){
    return{
      show:false,
      showIs:false,
      logout:false,
      messageList:[],
      size:0, // تعداد پیامهای دریافتی
      countRequestUser:0, // تعداد درخواست کاربر
      countEditUnit:0, //  برای درخواست ویرایش واحد
      msg:{},
      imgNav:require('../../assets/nav.png')
    }

},
  mounted() {
    this.$root.$on('NavBar', () => {
      this.getUnReadMsg()
    })

  },

  methods: {
    ...mapMutations({
      setDrawer: 'SET_DRAWER',
      setMini: 'SET_MINI',
    }),

    getUnReadMsg() {
      Message_se.getUnReadMessage().then(res => {
        this.size = res.data.size;

      })
    },
    getUnReadRequest() {
      Request_se.getPage().then(res => {
        this.countRequestUser = res.data.count;
        this.countEditUnit = res.data.count2;
      })
    },
    // forSee: function (n) {
    //   this.msg=n
    //   Message_se.readMessage(n.id)
    //   this.showIs = true
    //
    // },
  },
    created() {
    this.getUnReadMsg();
    this.getUnReadRequest()();
  }
}
</script>

<style scoped>

</style>